import { Text } from '@chakra-ui/react';
import * as React from 'react';

export const NoMembershipStatus: React.FC<{
  name: string;
  shouldBeAdminView: boolean;
}> = ({ name, shouldBeAdminView }) => {
  return (
    <Text color="gray.500">
      {shouldBeAdminView
        ? `${name} does not have any membership status`
        : 'You have no current or upcoming membership.'}
    </Text>
  );
};
